// extracted by mini-css-extract-plugin
export var contentBody = "_bm-9";
export var headerImage = "_bm-2";
export var imageButton = "_bm-7";
export var imageButtonIcon = "_bm-8";
export var imageHeader = "_bm-4";
export var imageHeaderText = "_bm-5";
export var imageOverlay = "_bm-3";
export var imageTitle = "_bm-6";
export var imageWrapper = "_bm-1";
export var taskList = "_bm-a";
export var widget = "_bm-0";